// extracted by mini-css-extract-plugin
module.exports = {"root":"Textarea_root__2iPbS","error":"Textarea_error__rIghf","readonly":"Textarea_readonly__Gl-xf","disabled":"Textarea_disabled__915_a"};